import lazyWithRetry from 'utils/lazyWithRetry';

// project imports
import AuthLayout from 'layout/Auth';
import Loadable from 'components/Loadable';
import { APP_AUTH, AuthProvider } from 'config';

// firebase auth
const FirebaseAuthLogin = Loadable(lazyWithRetry(() => import('pages/auth/firebase/login')));
// Self-registration is disabled: admin is an internal tool and accounts are
// provisioned, not signed up for. Route is commented out below; kept with it.
// const FirebaseAuthRegister = Loadable(lazyWithRetry(() => import('pages/auth/firebase/register')));
const FirebaseAuthForgotPassword = Loadable(
  lazyWithRetry(() => import('pages/auth/firebase/forgot-password'))
);
const FirebaseAuthResetPassword = Loadable(
  lazyWithRetry(() => import('pages/auth/firebase/reset-password'))
);

const FirebaseAuthResetPasswordConfirm = Loadable(
  lazyWithRetry(() => import('pages/auth/firebase/reset-password-confirm'))
);

const FirebaseAuthCodeVerification = Loadable(
  lazyWithRetry(() => import('pages/auth/firebase/code-verification'))
);
const FirebaseAuthCheckMail = Loadable(lazyWithRetry(() => import('pages/auth/firebase/check-mail')));

// Route is commented out below; kept together with it.
// const FirebaseAuthSetup2FA = Loadable(
//   lazyWithRetry(() => import('pages/auth/firebase/setup-2fa'))
// );

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          // For FIREBASE this is '/', so auth routes are /login, /forgot-password, etc.
          path: APP_AUTH === AuthProvider.FIREBASE ? '/' : 'firebase',
          children: [
            { path: 'login', element: <FirebaseAuthLogin /> },
            //{ path: 'register', element: <FirebaseAuthRegister /> },
            { path: 'forgot-password', element: <FirebaseAuthForgotPassword /> },
            { path: 'reset-password', element: <FirebaseAuthResetPassword /> },
            { path: 'reset-password-confirm', element: <FirebaseAuthResetPasswordConfirm /> },
            { path: 'code-verification', element: <FirebaseAuthCodeVerification /> },
            { path: 'check-mail', element: <FirebaseAuthCheckMail /> },
            //{ path: 'setup-2fa', element: <FirebaseAuthSetup2FA /> }
            // verify-email route removed - no longer needed since users are created with emailVerified: true
          ]
        }
      ]
    }
  ]
};

export default LoginRoutes;
